<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>


        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">Jenis Pemakaian / Penggunaan</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          v-if="dialog.form"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }} Jenis Pemakaian / Penggunaan 
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider 
                    name="Nama" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>

                      Nama
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Fasilitas Umum"

                      hide-details

                      v-model="form.name"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;"
                      class="mb-4">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.name !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>
              
            <v-card-actions
              class="pa-4">
              <div v-if="message.error.length > 0"
                class="text-center">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form_jenis"
          @keydown.esc="dialog.form_jenis = false"
          :fullscreen="dialog.fullscreen"
          v-if="dialog.form_jenis"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <div class="d-flex pa-4 align-start" style="width: 100%;">
              <div
                class="fs-15 font-weight-bold">
                {{ form_jenis.id === '' ? 'Tambah' : 'Ubah' }} Jenis Pemakaian / Penggunaan <span v-if="selected.jenis_parent.length > 0">{{ selected.jenis_parent[0].name }} </span>
              </div>
              <div class="ml-auto d-flex align-center">
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
    
                <v-icon 
                  @click="dialog.form_jenis = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </div>
            </div>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 mt-2 mb-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider 
                    name="Nama" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>

                      Nama
                    </div>

                    <v-text-field
                      v-on:keyup.enter="saveJenis()"
                      
                      outlined
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Fasilitas Umum"

                      hide-details

                      v-model="form_jenis.name"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;"
                      class="mb-4">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form_jenis.name !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>
              
            <v-card-actions
              class="pa-4">
              <div v-if="message.error.length > 0"
                class="text-center">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
              <v-spacer/>

              <v-btn
                @click="saveJenis()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form_jenis = false; resetJenis();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete_jenis"
          @keydown.esc="dialog.delete_jenis = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete_jenis = false; dialog.fullscreen = false; selected.delete_jenis = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">Jenis Pemakaian / Penggunaan</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletesJenis()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete_jenis = false; dialog.fullscreen = false; selected.delete_jenis = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form_harga"
          @keydown.esc="dialog.form_harga = false"
          :fullscreen="dialog.fullscreen"
          v-if="dialog.form_harga"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <div class="d-flex pa-4 align-start" style="width: 100%;">
              <div
                class="fs-15 font-weight-bold">
                {{ form_harga.id === '' ? 'Tambah' : 'Ubah' }} Harga di <span v-if="selected.harga_parent.length > 0">{{ selected.harga_parent[0].name }} </span>
              </div>
              <div class="ml-auto d-flex align-center">
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
    
                <v-icon 
                  @click="dialog.form_harga = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </div>
            </div>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 mt-2 mb-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider 
                    name="Pilih Hari" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>

                      Pilih Hari
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="saveHarga()"
                      
                      outlined
                      rounded
                      dense
                      :items="[
                        {
                          text: 'Semua Hari',
                          value: 'all'
                        },
                        {
                          text: 'Hari Sabtu / Minggu / Hari Libur Nasional',
                          value: 'weekend'
                        },
                        {
                          text: 'Selain Hari Sabtu / Minggu / Hari Libur Nasional',
                          value: 'weekday'
                        }
                      ]"

                      :color="set_color"
                      placeholder="Pilih Hari"

                      hide-details

                      v-model="form_harga.day"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;"
                      class="mb-4">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form_harga.day !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>

                  <ValidationProvider 
                    name="Harga" 
                    rules="required|min_value:0" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>

                      Harga
                    </div>

                    <v-currency-field
                      v-on:keyup.enter="saveHarga()"
                      
                      outlined
                      rounded
                      dense

                      :color="set_color"
                      placeholder="1.000.000"

                      hide-details
                      prefix="Rp"

                      v-model="form_harga.value"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;"
                      class="mb-4">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form_harga.value !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-currency-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>
              
            <v-card-actions
              class="pa-4">
              <div v-if="message.error.length > 0"
                class="text-center">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
              <v-spacer/>

              <v-btn
                @click="saveHarga()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form_harga = false; resetHarga();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete_harga"
          @keydown.esc="dialog.delete_harga = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete_harga = false; dialog.fullscreen = false; selected.delete_harga = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">Harga Pemakaian / Penggunaan</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletesHarga()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete_harga = false; dialog.fullscreen = false; selected.delete_harga = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>

          <v-row
            class="pa-0">
            <v-col 
              cols="12"
              class="py-0">
              <div>
                <div class="font_weight_600 fs-14 black--text">
                  <div class="mb-2">
                    Jenis & Harga disewa
                  </div>
                  <v-btn
                    color="#4B4B4B"
                    elevation="0"
                    x-small
                    @click="reset(); dialog.form = true"
                    min-height="25"
                    class="fs-12 white--text text-capitalize d-flex align-center"
                    style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1)); margin-bottom: 3px;;">
                    <v-icon size="13">mdi-plus-circle-multiple</v-icon>
                    
                    <span
                      class="ml-2">
                      Tambah
                    </span>
                  </v-btn>
                </div>
                <div>
                  <div>
                    <v-row>
                      <v-col cols="12" md="12" class="pt-0 mb-1" v-for="(item, i) in list" :key="i">
                        <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                          <tr>
                            <th colspan="2" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; background: aliceblue;" class="black--text">
                              <div class="">
                                <div>
                                  {{ item.name }}
                                </div>
                                <div class="d-flex align-center">
                                  <v-btn
                                    color="#4B4B4B"
                                    elevation="0"
                                    x-small
                                    @click="resetJenis(item); dialog.form_jenis = true; selected.jenis_parent[0] = item"
                                    min-height="25"
                                    class="fs-11 white--text text-capitalize mr-1 d-flex align-center"
                                    style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1)); margin-bottom: 3px;;">
                                    <v-icon size="13">mdi-plus-circle-multiple</v-icon>
                                    
                                    <span
                                      class="ml-2">
                                      Tambah Jenis
                                    </span>
                                  </v-btn>
                                  <v-btn
                                    @click="reset(i); dialog.form = true"
  
                                    min-width="25"
                                    height="25"
                                    x-small
                                    rounded
                                    color="blue"
                                    elevation="0"
                                    class="white--text text-capitalize fs-11 mx-1 d-flex align-center"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="14">mdi-square-edit-outline</v-icon>
                      
                                    <span
                                      class="ml-2">
                                      Ubah
                                    </span>
                                  </v-btn>
                                  <v-btn
                                    @click="toDelete(item.id)"
                                    
                                    min-width="25" min-height="25"
                                    x-small
                                    rounded
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize fs-11 mx-1 d-flex align-center"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="15">mdi-trash-can-outline</v-icon>
                      
                                    <span
                                      class="ml-2">
                                      Hapus
                                    </span>
                                  </v-btn>
                                </div>
                              </div>
                            </th>
                          </tr>
                          <tr v-for="(event, j) in item.event" :key="j">
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;" class="black--text">
                              {{ event.name }}
                              <div class="d-flex align-center">
                                <v-btn
                                  color="#4B4B4B"
                                  elevation="0"
                                  x-small
                                  @click="resetHarga(item, event, i, j); dialog.form_harga = true; selected.jenis_parent[0] = item; selected.harga_parent[0] = event"
                                  min-height="25"
                                  class="fs-10 white--text text-capitalize mr-1 d-flex align-center"
                                  style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1)); margin-bottom: 3px;;">
                                  <v-icon size="13">mdi-plus-circle-multiple</v-icon>
                                  
                                  <span
                                    class="ml-2">
                                    Tambah Harga
                                  </span>
                                </v-btn>
                                <v-btn
                                  @click="resetJenis(item, i, j); dialog.form_jenis = true; selected.jenis_parent[0] = item"

                                  min-width="25"
                                  height="25"
                                  x-small
                                  rounded
                                  color="blue"
                                  elevation="0"
                                  class="white--text text-capitalize fs-10 mx-1 d-flex align-center"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon size="14">mdi-square-edit-outline</v-icon>
                    
                                  <span
                                    class="ml-2">
                                    Ubah
                                  </span>
                                </v-btn>
                                <v-btn
                                  @click="toDeleteJenis(event.id)"
                                  
                                  min-width="25" min-height="25"
                                  x-small
                                  rounded
                                  color="red"
                                  elevation="0"
                                  class="white--text text-capitalize fs-10 mx-1 d-flex align-center"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon size="15">mdi-trash-can-outline</v-icon>
                    
                                  <span
                                    class="ml-2">
                                    Hapus
                                  </span>
                                </v-btn>
                              </div>
                            </td>
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 0px; text-align: left; width: 100%;" class="black--text">
                              <table style="width: 100%; border-collapse: collapse;" v-for="(harga, k) in event.price" :key="k">
                                <tr :style="event.price.length > k + 1 ? 'border-bottom: 1px solid #ededed;' : ''">
                                  <div class="px-3 py-1">
                                    <div class="fs-10">
                                      {{ harga.day == 'all' ? 'Semua Hari' : harga.day == 'weekend' ? 'Hari Sabtu / Minggu / Hari Libur Nasional' : 'Selain Hari Sabtu / Minggu / Hari Libur Nasional' }}
                                    </div>
                                    <div>
                                      {{ harga.value | price }}
                                    </div>
                                    <div class="d-flex align-center">
                                      <v-btn
                                        @click="resetHarga(item, event, i, j, k); dialog.form_harga = true; selected.jenis_parent[0] = item; selected.harga_parent[0] = event;"
  
                                        min-width="25"
                                        height="25"
                                        x-small
                                        rounded
                                        color="blue"
                                        elevation="0"
                                        class="white--text text-capitalize fs-10 mr-1 d-flex align-center"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon size="14">mdi-square-edit-outline</v-icon>
                          
                                        <span
                                          class="ml-2">
                                          Ubah
                                        </span>
                                      </v-btn>
                                      <v-btn
                                        @click="toDeleteHarga(harga.id)"
                                        
                                        min-width="25" min-height="25"
                                        x-small
                                        rounded
                                        color="red"
                                        elevation="0"
                                        class="white--text text-capitalize fs-10 mx-1 d-flex align-center"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon size="15">mdi-trash-can-outline</v-icon>
                          
                                        <span
                                          class="ml-2">
                                          Hapus
                                        </span>
                                      </v-btn>
                                    </div>
                                  </div>
                                </tr>
                                <!-- <tr>
                                  <div class="px-3 py-1">
                                    <div class="fs-10">
                                      Selain hari diatas
                                    </div>
                                    <div>
                                      Rp 4.500.000
                                    </div>
                                  </div>
                                </tr> -->
                              </table>

                              <div v-if="event.price.length == 0" style="font-size: 12px; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                -
                              </div>
                            </td>
                          </tr>
                          <tr v-if="item.event.length == 0">
                            <td colspan="2" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 280px; min-width: 280px; max-width: 280px;" class="black--text">
                              Belum Ada Jenis Pemakaian / Penggunaan
                            </td>
                          </tr>
                          <!-- <tr>
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 280px; min-width: 280px; max-width: 280px;" class="black--text">
                              Organisasi Sosial Kemasyarakatan
                            </td>
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 0px; text-align: left; width: 100%;" class="black--text">
                              <table style="width: 100%; border-collapse: collapse;">
                                <tr>
                                  <div class="px-3 py-1">
                                    <div>
                                      Rp 2.000.000
                                    </div>
                                  </div>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 280px; min-width: 280px; max-width: 280px;" class="black--text">
                              Organisasi Pendidikan
                            </td>
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 0px; text-align: left; width: 100%;" class="black--text">
                              <table style="width: 100%; border-collapse: collapse;">
                                <tr>
                                  <div class="px-3 py-1">
                                    <div>
                                      Rp 1.500.000
                                    </div>
                                  </div>
                                </tr>
                              </table>
                            </td>
                          </tr> -->
                        </table>
                      </v-col>
                    </v-row>
                  </div>
                  <div v-if="list.length == 0" class="text-center py-5">
                    <!-- <v-icon size="100" color="grey lighten-1">mdi-emoticon-sad-outline</v-icon> -->
                    <v-img 
                      class="mx-auto"
                      contain
                      alt="vuetify"
                      :width="40"
                      :height="40"
                      :src="require('@/assets/image/empty.png')">
                    </v-img>
                    <div class="fs-12 black--text">
                      Jenis belum tersedia
                    </div>
                  </div>
                  <!-- <div class="d-flex align-center mt-0 mb-1">
                    <div>
                      <v-icon
                        color="#AD1457"
                        size="16"
                      >mdi-face-woman-shimmer</v-icon>
                    </div>
                    <div class="black--text text-lighten-1 fs-13 pt-1 ml-3">
                      Tempat Rias
                    </div>
                  </div>
                  <div class="d-flex align-center mt-0 mb-1">
                    <div>
                      <v-icon
                        color="#1B5E20"
                        size="16"
                      >mdi-forest</v-icon>
                    </div>
                    <div class="black--text text-lighten-1 fs-13 pt-1 ml-3">
                      Halaman Depan
                    </div>
                  </div> -->
                </div>
              </div>
            </v-col>
          </v-row>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>
  
<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  
  export default {
    data: () => ({
      dialog: {
        form: false,
        fullscreen: false,
        delete: false,
        snackbar: false,
        form_jenis: false,
        delete_jenis: false,
        form_harga: false,
        delete_harga: false
      },
      list: [],
      form: {
        id: '',
        name: ''
      },
      form_jenis: {
        id: '',
        name: '',
        event_cat_id: ''
      },
      form_harga: {
        id: '',
        name: '',
        value: '',
        event_cat_id: '',
        event_id: '',
        day: ''
      },
      selected: {
        row: [],
        delete: [],
        delete_jenis: [],
        delete_harga: [],
        jenis_parent: [],
        harga_parent: []
      },
      message: {
        success: '',
        error: ''
      },
      process: {
        form: false,
        submit: false,
        delete: false,
        load: false
      },
    }),
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      // this.$refs.calendar.checkChange()
      this.fetch()
    },
    methods: {

      async fetch () {
        let params = {
          product_id: this.$route.params.id
        }
        await get(`admin/event_category/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.list = []
            res.results.data.map(item => {
              this.list.push(
                {
                  ...item,
                  event: []
                }
              )
            })
          }

          this.list.map((item, index) => {
            let params = {
              event_cat_id: item.id
            }
            get(`admin/event/data`, { params })
            .then(response => {
              let res = response.data

              if (res.status === 200) {
                this.list[index].event = []
                res.results.data.map(item => {
                  this.list[index].event.push({
                    ...item,
                    price: []
                  })
                })
                item.event.map((event, indexs) => {
                  let params = {
                    event_id: event.id
                  }

                  console.log(params)
                  get(`admin/product_price/data`, { params })
                  .then(response => {
                    let res = response.data
    
                    if (res.status === 200) {
                      this.list[index].event[indexs].price = []
                      res.results.data.map(item => {
                        this.list[index].event[indexs].price.push({
                          ...item,
                          value: item.value*1
                        })
                      })
                    }
                  })
                })
              }
            })

          })

          // this.list.map((item, index) => {

          //   console.log(item.name)
          //   console.log(item.event)

          //   item.event.map((event, indexs) => {
          //     let params_harga = {
          //       event_id: event.id
          //     }
          //     get(`admin/product_price/data`, { params_harga })
          //     .then(response => {
          //       let res = response.data

          //       if (res.status === 200) {
          //         this.list[index].event[indexs].price = res.results.data
          //       }
          //     })
          //   })
          // })
        })
      },
      
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: index !== undefined ? this.list[index].id : '',
          name: index !== undefined ? this.list[index].name : ''
        }

        this.process.form = false

        this.message.error = ''
      },
      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          requestAnimationFrame(() => requestAnimationFrame(() => open()))
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
      updateRange ({ start, end }) {
        const events = []

        const min = new Date(`${start.date}T00:00:00`)
        const max = new Date(`${end.date}T23:59:59`)
        const days = (max.getTime() - min.getTime()) / 86400000
        const eventCount = this.rnd(days, days + 20)

        for (let i = 0; i < eventCount; i++) {
          const allDay = this.rnd(0, 3) === 0
          const firstTimestamp = this.rnd(min.getTime(), max.getTime())
          const first = new Date(firstTimestamp - (firstTimestamp % 900000))
          const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
          const second = new Date(first.getTime() + secondTimestamp)

          events.push({
            name: this.names[this.rnd(0, this.names.length - 1)],
            start: first,
            end: second,
            color: this.colors[this.rnd(0, this.colors.length - 1)],
            timed: !allDay,
          })
        }

        this.events = events
      },
      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },

      // POST FASILITAS

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'admin/event_category/add' : 'admin/event_category/update'

          // SAVE TO REST API
          await post(url, {
            data: {
              id: this.form.id,
              name: this.form.name,
              product_id: this.$route.params.id
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetch()
              this.reset()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },


      // DELETE FASILITAS

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/event_category/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },


      resetJenis (item, par_index, index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form_jenis = {
          id: index !== undefined ? this.list[par_index].event[index].id : '',
          name: index !== undefined ? this.list[par_index].event[index].name : '',
          event_cat_id: item.id
        }

        this.process.form = false

        this.message.error = ''
      },


      saveJenis () {
        this.message.error = ''

        this.process.form = true

        let url = this.form_jenis.id === '' ? 'admin/event/add' : 'admin/event/update'

        // SAVE TO REST API
        post(url, {
          data: {
            id: this.form_jenis.id,
            name: this.form_jenis.name,
            product_id: this.$route.params.id,
            event_cat_id: this.form_jenis.event_cat_id
          }
        })
        .then(response => {
          let res = response.data
          
          this.process.form = false

          if (res.status === 200) {
            this.dialog.form_jenis = false

            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
            this.resetJenis()

          } else {
            this.message.error = res.message
          }
        })
      },

      toDeleteJenis (id) {
        this.selected.delete_jenis = [id]

        this.dialog.delete_jenis = true
      },

      deletesJenis () {
        this.message.error = ''

        this.process.delete = true

        post(`admin/event/delete`, {
          data: {
            id: this.selected.delete_jenis[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete_jenis = false

            this.selected.row = []
            this.selected.delete_jenis = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },


      resetHarga (item, event, par_index, event_index, index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form_harga = {
          id: index !== undefined ? this.list[par_index].event[event_index].price[index].id : '',
          value: index !== undefined ? this.list[par_index].event[event_index].price[index].value : '',
          event_cat_id: item.id,
          event_id: event.id,
          day: index !== undefined ? this.list[par_index].event[event_index].price[index].day : ''
        }

        this.process.form = false

        this.message.error = ''
      },


      saveHarga () {
        this.message.error = ''

        this.process.form = true

        let url = this.form_harga.id === '' ? 'admin/product_price/add' : 'admin/product_price/update'

        // SAVE TO REST API
        post(url, {
          data: {
            id: this.form_harga.id,
            value: this.form_harga.value,
            product_id: this.$route.params.id,
            event_cat_id: this.form_harga.event_cat_id,
            event_id: this.form_harga.event_id,
            day: this.form_harga.day
          }
        })
        .then(response => {
          let res = response.data
          
          this.process.form = false

          if (res.status === 200) {
            this.dialog.form_harga = false

            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
            this.resetHarga()

          } else {
            this.message.error = res.message
          }
        })
      },

      toDeleteHarga (id) {
        this.selected.delete_harga = [id]

        this.dialog.delete_harga = true
      },

      deletesHarga () {
        this.message.error = ''

        this.process.delete = true

        post(`admin/product_price/delete`, {
          data: {
            id: this.selected.delete_harga[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete_harga = false

            this.selected.row = []
            this.selected.delete_harga = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },
    },
  }
</script>